import store from '@/store'
export default [
  {
    path: '/divisions',
    name: 'division',
    meta: { requiresAuth: true },
    component: () => import('@/pages/division/index.vue')
  },
  {
    path: '/divisions/:id',
    name: 'division-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/division/index.vue'),
    props: route => ({ editData: route.params.editData }),
    beforeEnter: async (to, from, next) => {
      let response = await store.dispatch('division/find', to.params.id)
      let { ...resource } = response.data
      to.params.editData = resource
      next()
    }
  }
]
